<template>
  <div></div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  created() {
    this.backMine()
  },
  methods: {
    backMine() {
      const page = {
        pageName: 'mine'
      }
      if(this.$isapp) {
        this.$WDJSBridge.jumpNAPage(JSON.stringify(page)).then(res=>{
            // this.$WDJSBridge.useBack().then(res=>{
            //     console.log('useBack 跳转成功', res)
            // }).catch(err=>{
            //     console.log('useBack 页面跳转错误', err)
            // })
            console.log('jumpNAPage 跳转成功', res)
        }).catch(err=>{
            console.log('jumpNAPage 页面跳转错误', err)
            // this.$router.replace({
            //   path: this.$route.query.backUrl,
            //   query: {
            //     goodsId: this.$route.query.goodsId
            //   }
            // })
            this.$router.replace({
              path: '/myPage'
            })
        });
      } else {
        this.$router.replace({
          path: '/myPage'
        })
      }
    }
  }
}
</script>

<style lang="less">
html,
body {
  background-color: #f8fafc;
}
</style>
<style lang="less" scoped>
</style>
